var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7318 16.9049V4.17347C12.7318 3.75139 12.5642 3.3466 12.2657 3.04815C11.9673 2.7497 11.5625 2.58203 11.1404 2.58203H7.95754C7.53546 2.58203 7.13068 2.7497 6.83222 3.04815C6.53377 3.3466 6.3661 3.75139 6.3661 4.17347V16.9049M3.18323 5.7649H15.9147C16.7936 5.7649 17.5061 6.47741 17.5061 7.35634V15.3135C17.5061 16.1924 16.7936 16.9049 15.9147 16.9049H3.18323C2.30431 16.9049 1.5918 16.1924 1.5918 15.3135V7.35634C1.5918 6.47741 2.30431 5.7649 3.18323 5.7649Z",
    stroke: "#221AFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.77a6f1e2832f377d78326d08d055a766.svg";
export { ForwardRef as ReactComponent };